(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moon-phase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zen-lunar-guide')) {
    class ZenLunarGuide extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.synodicDays = 29.530588853;
        this.synodicMs = this.synodicDays * 86400000;
        this.epoch = Date.UTC(2000, 0, 6, 18, 14, 0);
        this.locale = this.dataset.locale || 'en-CA';
        this.rootUrl = (this.dataset.rootUrl || '/').replace(/\/$/, '');
        this.phases = [
          {
            name: 'New Moon',
            guidance: 'Begin quietly. Choose one intention worth carrying into the cycle ahead.',
            focus: 'Set one clear intention',
            crystals: [
              ['Black Obsidian', 'black-obsidian', 'Ground and protect your intention'],
              ['Clear Quartz', 'clear-quartz', 'Clarify and amplify your focus'],
              ['Labradorite', 'labradorite', 'Support intuition and new beginnings']
            ]
          },
          {
            name: 'Waxing Crescent',
            guidance: 'Give your intention momentum. One small, deliberate action is enough.',
            focus: 'Take the next small step',
            crystals: [
              ['Citrine', 'citrine', 'Invite optimism and forward movement'],
              ['Carnelian', 'carnelian', 'Build courage and creative momentum'],
              ['Green Aventurine', 'green-aventurine', 'Welcome opportunity and growth']
            ]
          },
          {
            name: 'First Quarter',
            guidance: 'Meet resistance with clarity. Decide what matters, then keep moving.',
            focus: 'Choose and commit',
            crystals: [
              ['Carnelian', 'carnelian', 'Strengthen motivation and courage'],
              ["Tiger's Eye", 'tigers-eye', 'Stay grounded while making decisions'],
              ['Amethyst', 'amethyst', 'Quiet distraction and sharpen clarity']
            ]
          },
          {
            name: 'Waxing Gibbous',
            guidance: 'Refine what you started. Adjust the details without abandoning the vision.',
            focus: 'Refine and trust the process',
            crystals: [
              ['Amethyst', 'amethyst', 'Deepen trust and inner clarity'],
              ['Rose Quartz', 'rose-quartz', 'Stay open and receptive'],
              ['Labradorite', 'labradorite', 'Protect the energy behind your vision']
            ]
          },
          {
            name: 'Full Moon',
            guidance: 'Notice what has come into view. Celebrate what is working and release what is not.',
            focus: 'Illuminate and release',
            crystals: [
              ['Selenite', 'selenite', 'Cleanse and reset your space'],
              ['Rainbow Moonstone', 'rainbow-moonstone', 'Connect with intuition and lunar energy'],
              ['Clear Quartz', 'clear-quartz', 'Amplify clarity and intention']
            ]
          },
          {
            name: 'Waning Gibbous',
            guidance: 'Turn progress into gratitude. Share what you have learned and soften your pace.',
            focus: 'Reflect with gratitude',
            crystals: [
              ['Rose Quartz', 'rose-quartz', 'Lead reflection with compassion'],
              ['Moss Agate', 'moss-agate', 'Ground growth and abundance'],
              ['Lapis Lazuli', 'lapis-lazuli', 'Express insight with honesty']
            ]
          },
          {
            name: 'Last Quarter',
            guidance: 'Clear what feels complete. Make room before asking what comes next.',
            focus: 'Release what is finished',
            crystals: [
              ['Smoky Quartz', 'smoky-quartz', 'Ground and release heavy energy'],
              ['Black Tourmaline', 'black-tourmaline', 'Protect your energy while clearing'],
              ['Selenite', 'selenite', 'Refresh the energy around you']
            ]
          },
          {
            name: 'Waning Crescent',
            guidance: 'Rest is part of the ritual. Restore your energy and let the next cycle arrive.',
            focus: 'Rest and restore',
            crystals: [
              ['Lepidolite', 'lepidolite', 'Invite calm and emotional ease'],
              ['Selenite', 'selenite', 'Create a peaceful reset'],
              ['Aquamarine', 'aquamarine', 'Soothe the mind and encourage rest']
            ]
          }
        ];
        this.dateFormatter = new Intl.DateTimeFormat(this.locale, {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        });
        this.shortDateFormatter = new Intl.DateTimeFormat(this.locale, {
          month: 'short',
          day: 'numeric'
        });
        this.returnButton = this.querySelector('[data-return]');
        this.returnButton.addEventListener('click', () => this.showTonight());
        this.showTonight();
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      getMoonState(date) {
        const elapsed = date.getTime() - this.epoch;
        const normalized = ((elapsed % this.synodicMs) + this.synodicMs) % this.synodicMs;
        const fraction = normalized / this.synodicMs;
        const illumination = (1 - Math.cos(Math.PI * 2 * fraction)) / 2;
        const phaseIndex = Math.floor(fraction * 8) % 8;
        return {
          fraction,
          illumination,
          phaseIndex,
          ageDays: fraction * this.synodicDays,
          cycleStart: date.getTime() - normalized
        };
      }

      getUpcomingEvents(date) {
        const state = this.getMoonState(date);
        const segment = this.synodicMs / 8;
        const events = [];
        for (let phaseIndex = 0; phaseIndex < 8; phaseIndex += 1) {
          let target = state.cycleStart + phaseIndex * segment;
          if (target <= date.getTime() + 1000) target += this.synodicMs;
          events.push({ phaseIndex, target });
        }
        return events.sort((a, b) => a.target - b.target).slice(0, 4);
      }

      showTonight() {
        const now = new Date();
        const state = this.getMoonState(now);
        const events = this.getUpcomingEvents(now);
        this.previewing = false;
        this.selectedTarget = events[0].target;
        this.selectedPhaseIndex = events[0].phaseIndex;
        this.renderPhase(state.phaseIndex, state.fraction, state.illumination, state.ageDays, 'Current phase');
        this.renderEvents(events);
        this.returnButton.hidden = true;
        this.querySelector('[data-current-date]').textContent = this.dateFormatter.format(now);
        this.updateCountdown();
      }

      previewPhase(phaseIndex, target) {
        this.previewing = true;
        this.selectedTarget = target;
        this.selectedPhaseIndex = phaseIndex;
        const fraction = phaseIndex / 8;
        const illumination = (1 - Math.cos(Math.PI * 2 * fraction)) / 2;
        const targetDate = new Date(target);
        this.renderPhase(
          phaseIndex,
          fraction,
          illumination,
          fraction * this.synodicDays,
          `Previewing ${this.shortDateFormatter.format(targetDate)}`
        );
        this.returnButton.hidden = false;
        this.querySelectorAll('[data-event-button]').forEach((button) => {
          button.setAttribute('aria-pressed', String(Number(button.dataset.target) === target));
        });
        this.updateCountdown();
      }

      renderPhase(phaseIndex, fraction, illumination, ageDays, status) {
        const phase = this.phases[phaseIndex];
        this.querySelector('[data-status]').textContent = status;
        this.querySelector('[data-phase-name]').textContent = phase.name;
        this.querySelector('[data-illumination]').textContent = `${Math.round(illumination * 100)}%`;
        this.querySelector('[data-guidance]').textContent = phase.guidance;
        this.querySelector('[data-focus]').textContent = phase.focus;
        this.querySelector('[data-cycle-day]').textContent = `Day ${Math.max(1, Math.ceil(ageDays))}`;
        this.querySelector('[data-crystal-heading]').textContent = `Crystals for ${phase.name}`;
        this.querySelector('[data-orbit-progress]').style.strokeDashoffset = String(100 - fraction * 100);
        const canvas = this.querySelector('[data-moon-canvas]');
        canvas.setAttribute('aria-label', `${phase.name}, ${Math.round(illumination * 100)} percent illuminated`);
        this.drawMoon(canvas, fraction);
        this.renderCrystals(phase.crystals);
      }

      renderEvents(events) {
        const container = this.querySelector('[data-events]');
        container.replaceChildren();
        events.forEach((event) => {
          const phase = this.phases[event.phaseIndex];
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'zlg__event';
          button.dataset.eventButton = '';
          button.dataset.target = String(event.target);
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-label', `Preview ${phase.name} on ${this.dateFormatter.format(new Date(event.target))}`);

          const moon = document.createElement('canvas');
          moon.className = 'zlg__event-moon';
          moon.width = 96;
          moon.height = 96;
          moon.setAttribute('aria-hidden', 'true');
          this.drawMoon(moon, event.phaseIndex / 8);

          const copy = document.createElement('span');
          copy.className = 'zlg__event-copy';
          const name = document.createElement('strong');
          name.textContent = phase.name;
          const date = document.createElement('span');
          date.textContent = this.shortDateFormatter.format(new Date(event.target));
          copy.append(name, date);
          button.append(moon, copy);
          button.addEventListener('click', () => this.previewPhase(event.phaseIndex, event.target));
          container.append(button);
        });
      }

      renderCrystals(crystals) {
        const grid = this.querySelector('[data-crystal-grid]');
        grid.replaceChildren();
        crystals.forEach((crystal, index) => {
          const link = document.createElement('a');
          link.className = 'zlg__crystal-card';
          link.href = `${this.rootUrl}/collections/${crystal[1]}`;
          link.setAttribute('aria-label', `Shop ${crystal[0]} collection`);

          const number = document.createElement('span');
          number.className = 'zlg__crystal-number';
          number.textContent = String(index + 1).padStart(2, '0');

          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = crystal[0];
          const reason = document.createElement('small');
          reason.textContent = crystal[2];
          copy.append(title, reason);

          const arrow = document.createElement('span');
          arrow.className = 'zlg__arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '→';
          link.append(number, copy, arrow);
          grid.append(link);
        });
      }

      updateCountdown() {
        if (!this.selectedTarget) return;
        let remaining = Math.max(0, this.selectedTarget - Date.now());
        if (remaining === 0 && !this.previewing) {
          this.showTonight();
          return;
        }
        const days = Math.floor(remaining / 86400000);
        remaining -= days * 86400000;
        const hours = Math.floor(remaining / 3600000);
        remaining -= hours * 3600000;
        const minutes = Math.floor(remaining / 60000);
        remaining -= minutes * 60000;
        const seconds = Math.floor(remaining / 1000);
        const phase = this.phases[this.selectedPhaseIndex];
        this.querySelector('[data-countdown-label]').textContent = `${phase.name} in`;
        this.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
        this.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
        this.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
        this.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
      }

      drawMoon(canvas, fraction) {
        const context = canvas.getContext('2d');
        if (!context) return;
        const size = canvas.width;
        const centre = size / 2;
        const radius = size * 0.43;
        const image = context.createImageData(size, size);
        const lightX = Math.sin(Math.PI * 2 * fraction);
        const lightZ = -Math.cos(Math.PI * 2 * fraction);
        const craters = [
          [-0.31, -0.21, 0.12], [0.24, -0.28, 0.09], [0.34, 0.13, 0.07],
          [-0.14, 0.29, 0.1], [0.02, -0.02, 0.055], [-0.4, 0.12, 0.05]
        ];

        for (let y = 0; y < size; y += 1) {
          for (let x = 0; x < size; x += 1) {
            const normalizedX = (x - centre) / radius;
            const normalizedY = (y - centre) / radius;
            const distance = normalizedX * normalizedX + normalizedY * normalizedY;
            if (distance > 1) continue;
            const normalizedZ = Math.sqrt(1 - distance);
            const directLight = Math.max(0, normalizedX * lightX + normalizedZ * lightZ);
            const limb = Math.pow(normalizedZ, 0.28);
            let texture = 0.96 + 0.035 * Math.sin(x * 0.11 + y * 0.07) + 0.02 * Math.sin(x * 0.031 - y * 0.09);
            for (const crater of craters) {
              const dx = normalizedX - crater[0];
              const dy = normalizedY - crater[1];
              const craterDistance = Math.sqrt(dx * dx + dy * dy);
              if (craterDistance < crater[2]) texture -= 0.11 * (1 - craterDistance / crater[2]);
            }
            const brightness = (0.055 + 0.945 * Math.pow(directLight, 0.72)) * limb * texture;
            const index = (y * size + x) * 4;
            image.data[index] = Math.round(236 * brightness + 22 * (1 - brightness));
            image.data[index + 1] = Math.round(222 * brightness + 16 * (1 - brightness));
            image.data[index + 2] = Math.round(192 * brightness + 20 * (1 - brightness));
            image.data[index + 3] = Math.round(255 * Math.min(1, normalizedZ * 5));
          }
        }
        context.clearRect(0, 0, size, size);
        context.putImageData(image, 0, 0);
      }
    }

    customElements.define('zen-lunar-guide', ZenLunarGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
